import { guideSteps, platforms } from "@/mocks/site";

export default function ViewingGuide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
            Guide
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            高清中字、完整版怎么找？观影指南
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            想要画质清晰、字幕准确、内容完整的观影体验，方法比“哪里都能下”更重要。
            下面四条建议，能帮你在合法、稳定的前提下把片子看好。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((item) => (
            <article
              key={item.step}
              className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3 rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-list-check-2 text-primary-600"></i>
              常见观看途径一览
            </h3>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {platforms.map((platform) => (
                <div key={platform.name} className="rounded-md bg-background-100 border border-background-200 p-4">
                  <p className="text-sm font-medium text-foreground-900">{platform.name}</p>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {platform.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2 relative rounded-lg overflow-hidden min-h-[240px] flex items-end">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20watching%20setup%2C%20warm%20lamp%20light%2C%20television%20screen%20glow%20in%20a%20tasteful%20living%20room%2C%20amber%20and%20cream%20tones%2C%20editorial%20interior%20photography%2C%20no%20text&width=1200&height=700&seq=kfilm-guide-2026&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/40 to-foreground-950/10"></div>
            <div className="relative z-10 p-6">
              <p className="text-background-50 text-sm md:text-base leading-relaxed">
                提醒：请通过正规渠道观看，注意影片分级与自身观看年龄，
                共同尊重版权与创作者的心血。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}